import React from "react";
import "../styles/PrivacyPolicy.css";
import { MdEmail } from "react-icons/md";
import { FaGlobe } from "react-icons/fa";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container theme--2">
      <header className="privacy-header">
        <h1>Privacy Policy</h1>
        <p>
          Effective Date: <strong>May 5, 2026</strong>
        </p>
      </header>

      <section className="privacy-section">
        <h2>1. Introduction</h2>
        <p>
          This Privacy Policy applies to <strong>Savannah Shine Hub</strong>, 
          referred to as “we,” “our,” and “us.” By using our website 
          (<strong>https://savannahshinehub.com</strong>), you agree to the 
          terms outlined in this Policy.
        </p>
        <p>
          We are committed to protecting your personal data in accordance with 
          the <strong>Data Protection Act, 2019 (Kenya)</strong> and applicable 
          international standards.
        </p>
      </section>

      <section className="privacy-section">
        <h2>2. Information We Collect</h2>
        <p>We may collect the following information when you use our services:</p>
        <ul>
          <li>Full name</li>
          <li>Phone number</li>
          <li>Email address (optional)</li>
          <li>Service details (car wash, carpet cleaning, water refill)</li>
          <li>Location details (for carpet and water delivery services)</li>
          <li>Preferred booking date and time</li>
          <li>Additional notes or instructions</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>3. How We Use Your Information</h2>
        <p>Your information is used to:</p>
        <ul>
          <li>Process and manage your bookings</li>
          <li>Deliver requested services</li>
          <li>Communicate with you regarding appointments</li>
          <li>Improve our services and customer experience</li>
          <li>Prevent fraud or misuse of our platform</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>4. Sharing of Information</h2>
        <p>
          We do not sell your personal data. However, we may share your information with:
        </p>
        <ul>
          <li>Our staff and service providers to fulfill your request</li>
          <li>Logistics or delivery personnel (for water and carpet services)</li>
          <li>Authorities where required by law</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>5. Data Security</h2>
        <p>
          We implement appropriate security measures to protect your data, including:
        </p>
        <ul>
          <li>Secure servers and encrypted communication</li>
          <li>Restricted access to sensitive data</li>
          <li>Regular monitoring and system updates</li>
        </ul>
        <p>
          While we take security seriously, no online platform is 100% secure. 
          Use of our services is at your own risk.
        </p>
      </section>

      <section className="privacy-section">
        <h2>6. Data Retention</h2>
        <p>
          We retain your data only for as long as necessary to:
        </p>
        <ul>
          <li>Provide services</li>
          <li>Maintain business records</li>
          <li>Comply with legal requirements</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>7. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Withdraw consent at any time</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>8. Cookies</h2>
        <p>
          Our website may use cookies to improve user experience and analyze traffic. 
          You can disable cookies through your browser settings.
        </p>
      </section>

      <section className="privacy-section">
        <h2>9. Updates to This Policy</h2>
        <p>
          Savannah Shine Hub reserves the right to update this Privacy Policy. 
          Changes will be posted on this page with an updated effective date.
        </p>
      </section>

      <section className="privacy-section">
        <h2>10. Contact Us</h2>
        <p>If you have any questions or requests regarding your data:</p>

        <div className="contact-links">
          <p>
            <MdEmail className="contact-icon" />
            <a href="mailto:savannahshinehub@gmail.com">
              savannahshinehub@gmail.com
            </a>
          </p>
          <p>
            <FaGlobe className="contact-icon" />
            <a
              href="https://savannahshinehub.com"
              target="_blank"
              rel="noreferrer"
            >
              www.savannahshinehub.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;